import { PeriodPickerProps } from "@touche-lts/panel-ui/dist";

export enum LegalTableSortProps {
  TITLE = 'title',
  DATE = 'createdDate',
  PUBLISHED = 'status',
  CONTENT = 'content',
}

export enum LegalStatuses {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export interface LegalTableSearchProps {
  title: string;
  status: string;
  createdDate: PeriodPickerProps['period'];
}
